module.exports = __webpack_public_path__ + "static/media/xb7.796d6915.png";